import { toast } from '@/hooks/use-toast';

export function loginUrl(returnTo?: string, logoutFailed = false): string {
  const params = new URLSearchParams();
  if (returnTo) params.set('returnTo', returnTo);
  if (logoutFailed) params.set('error', 'logout_failed');
  return `/login.html${params.size ? `?${params}` : ''}`;
}

export async function logoutToLogin(returnTo?: string): Promise<void> {
  let failed = false;
  try {
    const response = await fetch('/api/auth/logout', { method: 'POST', credentials: 'same-origin' });
    if (!response.ok) throw new Error('Logout failed');
  } catch {
    failed = true;
    toast({ title: 'Logout failed. Please sign in again.', variant: 'destructive' });
  } finally {
    // Keep the failure visible on the destination after the toast host unmounts.
    window.location.href = loginUrl(returnTo, failed);
  }
}
